import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  ContentTitleImagePipe,
  HasTitleImagePipe,
  CurrentNewsOverviewBaseComponent,
  INewsState,
  BreadcrumbItem,
} from '@resident-nx/shared';
import { ROUTE } from '../../../models';
import { filter, take } from 'rxjs';
import { ContentCardPreset } from '../content-card/content-card.model';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { LoaderWebComponent } from '@resident-nx/web/ui';
import { InfiniteScrollWebComponent } from '../../atoms/infinite-scroll/infinite-scroll.component';
import { ContentCardWebComponent } from '../content-card/content-card.component';
import { BreadcrumbsWebComponent } from '../../atoms/breadcrumbs/breadcrumbs.component';

@Component({
  standalone: true,
  selector: 'rs-web-current-news-overview',
  templateUrl: './current-news-overview.component.html',
  styleUrls: ['./current-news-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BreadcrumbsWebComponent,
    ContentCardWebComponent,
    InfiniteScrollWebComponent,
    LoaderWebComponent,
    AsyncPipe,
    TranslateModule,
    ContentTitleImagePipe,
    HasTitleImagePipe,
  ],
})
export class CurrentNewsOverviewWebComponent extends CurrentNewsOverviewBaseComponent {
  public breadcrumbs: BreadcrumbItem[] = [
    {
      label: 'main_navigation_news_l',
      url: ROUTE.NEWS,
    },
    {
      label: 'news.current_news_l',
      url: `${ROUTE.NEWS}/${ROUTE.CURRENT_NEWS}`,
    },
  ];
  public presets = ContentCardPreset;

  constructor(
    newsStore: Store<INewsState>,
    private router: Router
  ) {
    super(newsStore, 30);
  }

  public onNavigate(event: string = ROUTE.NEWS) {
    this.router.navigate([event]);
  }

  public onTapArticle(id: string) {
    this.router.navigate([ROUTE.NEWS, ROUTE.CURRENT_NEWS, id]);
  }

  public onScroll() {
    this.newsActionState$
      .pipe(
        filter(state => !state.pending),
        take(1)
      )
      .subscribe(() => this.loadMoreNews());
  }
}
